//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationProvider } from 'vee-validate'
import FormLabel from '~/components/Form/FormLabel'

const CONTACT_TYPES = [
  {
    id: 'email',
    label: 'Email',
    placeholder: 'Ej: usuario@gmail.com',
    rules: 'required|email',
    nativeValue: 'email',
  },
  {
    id: 'phone',
    label: 'Teléfono',
    placeholder: 'Ej: +56987689876',
    nativeValue: 'phone',
    rules: 'required|internationalPhone',
  },
]

export default {
  name: 'FormInput',
  components: {
    FormLabel,
    ValidationProvider,
  },
  props: {
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
    ignoreValidGreen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    CONTACT_TYPES,
    innerValue: '',
    init: false,
    contactType: CONTACT_TYPES[0].id,
  }),
  computed: {
    fieldType() {
      return CONTACT_TYPES.find((ct) => ct.id === this.contactType)
    },
    computedRules() {
      return this.fieldType ? this.fieldType.rules : 'required'
    },
    computedPlaceholder() {
      return this.fieldType ? this.fieldType.placeholder : ''
    },
    computedLabel() {
      return this.fieldType ? this.fieldType.label : ''
    },
  },
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
      this.init = true
    },
    value(newVal) {
      this.innerValue = newVal
      this.init = true
    },
    contactType() {
      this.innerValue = ''
      this.init = false
      this.$emit('type', this.contactType)
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  mounted() {
    this.$emit('set-custom-errors', this.setErrors)
  },
  methods: {
    iconRightClick(event) {
      this.$emit('icon-right-click', event)
    },
    onBlur(event) {
      this.$emit('blur', event)
    },
    setErrors(listErrors) {
      this.$refs.provider.applyResult({
        errors: listErrors,
        valid: false,
        failedRules: {},
      })
    },
  },
}
